import {moneyInputValue} from '../../core/billing/billing.core.js';

/** Form control selector by field name; the names are the ones `validatePlatformCostForm` reads. */
const FIELDS = {
    supplier: '#cost-supplier',
    label: '#cost-label',
    invoiceNumber: '#cost-invoice-number',
    amount: '#cost-amount',
    periodFrom: '#cost-period-from',
    periodTo: '#cost-period-to',
    documentUrl: '#cost-document-url',
};

/**
 * Fills the form with `cost`, or empties it when `cost` is null (a new cost).
 *
 * @param {HTMLFormElement} form
 * @param {import('../../shell/types/billing.types.js').PlatformCostApiResponse | null} cost
 */
export function fillPlatformCostForm(form, cost) {
    form.querySelector(FIELDS.supplier).value = cost?.supplier ?? '';
    form.querySelector(FIELDS.label).value = cost?.label ?? '';
    form.querySelector(FIELDS.invoiceNumber).value = cost?.invoiceNumber ?? '';
    form.querySelector(FIELDS.amount).value = moneyInputValue(cost?.amount);
    form.querySelector(FIELDS.periodFrom).value = cost?.periodFrom ?? '';
    form.querySelector(FIELDS.periodTo).value = cost?.periodTo ?? '';
    form.querySelector(FIELDS.documentUrl).value = cost?.documentUrl ?? '';
    showPlatformCostFormErrors(form, {});
}

/**
 * @param {HTMLFormElement} form
 * @returns {Record<string, string>} the raw values as typed, by field name
 */
export function readPlatformCostForm(form) {
    return Object.fromEntries(
        Object.entries(FIELDS).map(([name, selector]) => [name, form.querySelector(selector).value]),
    );
}

/**
 * Shows one message under each field named in `errors` and clears the others; the first
 * offending field gets focus.
 *
 * @param {HTMLFormElement} form
 * @param {Record<string, string>} errors message by field name
 */
export function showPlatformCostFormErrors(form, errors) {
    for (const [name, selector] of Object.entries(FIELDS)) {
        const message = errors[name] ?? '';
        const error = form.querySelector(`#cost-error-${name}`);
        error.textContent = message;
        error.hidden = !message;
        form.querySelector(selector).setAttribute('aria-invalid', String(Boolean(message)));
    }
    const first = Object.keys(FIELDS).find((name) => errors[name]);
    if (first) {
        form.querySelector(FIELDS[first]).focus();
    }
}
